<mat-card appearance="outlined">
    <p>La razón social o el CIF/NIF ya se encuentra registrado en Handly,
        ¿desea añadir los asientos contables a la entidad de socio existente? </p>
    <button mat-stroked-button (click)="startImport()">Si, añadir asientos</button>
    <button mat-stroked-button (click)="closeDialog()">Cancelar</button>
</mat-card>
